import React from 'react';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Text from '@amzn/meridian/text';
import { useTranslation } from 'src/arb-wrapper';

export interface DeleteConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  isDeleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  open,
  title,
  message,
  isDeleting = false,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} scrollContainer="modal" title={title} onClose={onCancel}>
      <Column spacing="300">
        <Text>{message}</Text>
      </Column>
      <ModalFooter>
        <Row alignmentHorizontal="end" spacing="200">
          <Button disabled={isDeleting} type="tertiary" onClick={onCancel}>
            {t('form_global_cancel')}
          </Button>
          <Button disabled={isDeleting} type="primary" onClick={onConfirm}>
            {isDeleting ? t('deleting') : t('form_global_delete')}
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
